export default __webpack_public_path__ + "static/media/princeIcon.554508b8.png";